<template>
  <div>
    <div class="mt-12 code-area">
      <!-- <span class="language-label">{{ language }}</span> -->
      <JOnlineCode
        :inputCode="inputCode"
        :language="language"
        v-model="inputContent"
        @success="success"
        @failed="failed"
        ref="codeInfo"
      />
    </div>
    <div class="bottom-area">
      <el-form label-width="80px" class="form-area">
        <el-form-item label="输出：">
          <el-input
            class="mt-12"
            type="textarea"
            :autosize="{ minRows: 2 }"
            placeholder="请输入运行答案"
            v-model="answerContent"
            :disabled="disabled"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="解析：">
          <el-input
            class="mt-12"
            type="textarea"
            :autosize="{ minRows: 2 }"
            placeholder="请输入解析"
            v-model="explainContent"
            :disabled="disabled"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <el-form v-if="projectInfo" class="project-info-area" label-width="80px">
        <el-form-item size="mini" label="项目名称：" v-if="projectInfo">
          <span class="project-name">{{ projectInfo.name }}</span>
        </el-form-item>
        <el-form-item size="mini" v-if="projectInfo" label="项目描述：">
          <span class="project-description">{{ projectInfo.description }}</span>
        </el-form-item>
        <el-form-item size="mini" label="项目列表：">
          <div
            class="file-item"
            v-for="(item, index) in projectInfo.fileList"
            :key="index"
            @click="downloadFile(item.path)"
          >
            {{ item.name }}
          </div>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script language="text/javascript">
import projectService from "@/global/service/project";
import { JOnlineCode } from "jiker-online-code";

export default {
  props: {
    language: {
      type: String,
      default: "python"
    },
    inputCode: {
      type: String,
      default: ""
    },
    outputCode: {
      type: [String, Array]
    },
    answer: {
      type: String,
      default: ""
    },
    explain: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    projectId: {
      type: String,
      default: ""
    }
  },
  components: {
    JOnlineCode
  },
  data() {
    return {
      inputContent: "",
      answerContent: this.answer || "",
      explainContent: this.explain || "",
      projectInfo: null
    };
  },
  watch: {
    inputContent(val) {
      this.$emit("update:inputCode", val);
    },
    answer(val) {
      this.answerContent = val;
    },
    explain(val) {
      this.explainContent = val;
    },
    answerContent(val) {
      this.$emit("update:answer", val);
    },
    explainContent(val) {
      this.$emit("update:explain", val);
    }
  },
  mounted() {
    if (this.projectId) {
      projectService.getCodingFileDetail(this.projectId).then(res => {
        this.projectInfo = {
          name: res.name,
          description: res.description,
          fileList: res.files
        };
      });
    }
  },
  methods: {
    success(res) {
      this.$emit("update:outputCode", res.data);
    },
    failed() {
      this.$message.error("运行错误，请检查输入是否正确");
    },
    downloadFile(url) {
      window.open(url);
    }
  }
};
</script>
<style type="text/css" lang="less" scoped>
.language-label {
  position: absolute;
  left: 70px;
  top: 10px;
  height: 30px;
  font-size: 14px;
  color: #0fc700;
  line-height: 30px;
}
.code-area {
  position: relative;
  height: 440px;
  text-align: left;
}
.bottom-area {
  background: #161718;
  padding-bottom: 12px;
  padding-right: 12px;
  display: flex;

  justify-content: space-between;
  .form-area {
    width: 100%;
  }
  .project-info-area {
    color: #fff;
    margin-top: 12px;
    min-width: 38%;
    overflow: auto;
    border-radius: 5px;
    text-align: start;
    /deep/ .el-form-item__label {
      height: 30px;
      font-size: 12px;
    }
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
    .file-item {
      font-size: 12px;
      color: #1890ff;
      cursor: pointer;
      line-height: 18px;
      word-break: break-all;
    }
    .project-name {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 12px;
    }
    .project-description {
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      font-size: 12px;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
.el-form-item {
  margin-bottom: 0;
}
/deep/.el-textarea__inner {
  background-color: #fff;
}
/deep/.el-form-item__label {
  color: #fff;
}
</style>
